import React, { useState } from 'react';
import { API_URL } from '../config';
import { pdf } from '@react-pdf/renderer';
import { toast } from 'react-toastify';
import { FaSpinner, FaFilePdf } from 'react-icons/fa';
import CreditNotePDF from './CreditNotePDF';
import { getCompanyDetails } from '../config/CompanyDetails';

// ============================================
// CREDIT NOTE PDF BUTTON
// Fetches the credit note detail (items + client + invoice) then generates
// a printable credit note PDF. Same pattern as the invoice PDF buttons.
// ============================================
const CreditNotePDFButton = ({ creditNoteId, creditNote, onSuccess, iconOnly }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerate = async () => {
    if (isGenerating) return;
    setIsGenerating(true);
    try {
      let detail = creditNote || null;
      if (!detail?.items && creditNoteId) {
        const res = await fetch(`${API_URL}/credit-notes/${creditNoteId || creditNote?.id}`);
        const data = await res.json();
        if (data.success) detail = data.credit_note;
      }
      if (!detail) {
        toast.error('Credit note not found');
        return;
      }

      const company = await getCompanyDetails();
      const blob = await pdf(<CreditNotePDF creditNote={detail} company={company} />).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `CreditNote_${detail.credit_note_number || 'CN'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 1000);

      toast.success(`✅ Credit note ${detail.credit_note_number || ''} downloaded`);
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Credit note PDF error:', error);
      toast.error('Failed to generate credit note PDF. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <button
      onClick={handleGenerate}
      disabled={isGenerating}
      title="Download Credit Note PDF"
      className={iconOnly
        ? "text-gray-400 hover:text-red-600 transition-colors p-1 bg-transparent shadow-none disabled:opacity-50"
        : "flex items-center gap-2 px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-xs font-medium disabled:opacity-50"}
    >
      {isGenerating ? <FaSpinner className="animate-spin" size={12} /> : <FaFilePdf size={16} />}
      {!iconOnly && (isGenerating ? 'Generating...' : 'Download Credit Note')}
    </button>
  );
};

export default CreditNotePDFButton;
